import { ReactElement } from "react";
import { GetStaticProps } from "next";
import { NextSeo } from "next-seo";
import { MainLayout } from "~/components/layouts/MainLayout";
import { StandardServicePage } from "~/components/service-pages/StandardServicePage";
import { PhotovoltaicInspectionContent as content } from "~/content/przeglad-instalacji-fotowoltaicznej/content.pl";
import { getRecentPostsForService, type PostMeta } from "~/lib/mdx";
import { getServiceBySlug } from "~/lib/services";
import { NextPageWithLayout } from "~/pages/_app";
import electricalAssessmentImage from "~/src/assets/images/hero-power-box.webp";
import electricalMaintenanceImage from "~/src/assets/images/elec_11.jpg";
import electricalChecklistImage from "~/src/assets/images/services-details-electric.webp";

type Props = {
  recentPosts: PostMeta[];
};

const serviceSlug = "przeglad-instalacji-fotowoltaicznej";
const service = getServiceBySlug(serviceSlug);

if (!service) {
  throw new Error(`Service not found: ${serviceSlug}`);
}

const pageUrl = `${(
  process.env.NEXT_PUBLIC_BASE_URL ?? "https://inspektomat.pl"
).replace(/\/+$/, "")}${service.href}`;

const sectionImages = [
  {
    src: electricalAssessmentImage,
    alt: "Kontrola instalacji fotowoltaicznej i zabezpieczeń elektrycznych",
  },
  {
    src: electricalMaintenanceImage,
    alt: "Diagnostyka falownika i parametrów pracy instalacji PV",
  },
  {
    src: electricalChecklistImage,
    alt: "Raport z przeglądu instalacji fotowoltaicznej",
  },
] as const;

const PhotovoltaicInspectionPage: NextPageWithLayout<Props> = ({
  recentPosts,
}) => {
  return (
    <StandardServicePage
      serviceSlug={serviceSlug}
      content={content}
      sectionImages={sectionImages}
      recentPosts={recentPosts}
    />
  );
};

PhotovoltaicInspectionPage.getLayout = function GetLayout(
  page: ReactElement
) {
  return (
    <MainLayout>
      <NextSeo
        title={content.seo.title}
        description={content.seo.description}
        openGraph={{
          title: content.seo.title,
          description: content.seo.description,
          url: pageUrl,
        }}
      />
      {page}
    </MainLayout>
  );
};

export default PhotovoltaicInspectionPage;

export const getStaticProps: GetStaticProps<Props> = async () => {
  return {
    props: {
      recentPosts: getRecentPostsForService(serviceSlug),
    },
  };
};
